import React from 'react';

/** Мерцающая карточка-заглушка на время загрузки списка заказов. */
export function SkeletonOrderCard() {
  return (
    <div className="fc-skel-card" aria-hidden>
      <div className="fc-skel-card__customer">
        <span className="fc-skel fc-skel--avatar" />
        <span className="fc-skel fc-skel--line" style={{ width: '46%' }} />
      </div>
      <span className="fc-skel fc-skel--line" style={{ width: '70%', height: 15, marginBottom: 6 }} />
      <span className="fc-skel fc-skel--line" style={{ width: '40%', marginBottom: 10 }} />
      <div className="fc-skel-card__grid">
        <span className="fc-skel fc-skel--cell" />
        <span className="fc-skel fc-skel--cell" />
        <span className="fc-skel fc-skel--cell" />
      </div>
    </div>
  );
}

/** Список карточек-заглушек. */
export function SkeletonOrderList({ count = 3 }: { count?: number }) {
  return (
    <div className="fc-skel-list">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonOrderCard key={i} />
      ))}
    </div>
  );
}

/** Мерцающая строка-заглушка на время загрузки списка сообщений. */
export function SkeletonInboxRow() {
  return (
    <div className="fc-skel-row" aria-hidden>
      <span className="fc-skel fc-skel--avatar fc-skel--avatar-lg" />
      <div className="fc-skel-row__main">
        <span className="fc-skel fc-skel--line" style={{ width: '38%' }} />
        <span className="fc-skel fc-skel--line" style={{ width: '62%' }} />
      </div>
    </div>
  );
}

export function SkeletonInboxList({ count = 4 }: { count?: number }) {
  return (
    <div className="fc-skel-list">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonInboxRow key={i} />
      ))}
    </div>
  );
}
